// NEW: UI_REVAMP
import { Button, useBreakpointValue } from '@chakra-ui/react';
import GradientBox from '../box/GradientBox';

const VARIANTS = {
	numberPick: {
		default: {
			bg: '#8774FE',
			color: 'white',
		},
		selected: {
			bg: 'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)',
			color: '#111',
			boxShadow: '2px 2px 4px 0 rgba(255, 255, 255, 0.55) inset, -2px -2px 4px 0 #EC4A14 inset',
		},
		disabled: {
			bg: '#DAD4FF',
			color: '#AFA2FE',
		},
		soldOut: {
			bg: '#8774FE',
			color: '#6052B4',
		},
	},
	quickPick: {
		default: {
			bg: '#E2DEFF',
			color: { base: '#142FDC', lg: '#111' },
		},
		selected: {
			bg: { base: 'linear-gradient(180deg, #FEDD8B 0%, #F5A911 100%)', lg: '#FDFBED' },
			color: '#111',
			boxShadow: {
				base: '2px 2px 4px 0 rgba(255,255,255,0.55) inset, -2px -2px 4px 0 #EC4A14 inset',
				lg: 'none',
			},
		},
		disabled: {
			bg: '#E2DEFF',
			color: { base: '#1634F2', lg: '#111111' },
		},
	},
	timePick: {
		default: {
			bg: 'white',
			color: '#2C2203',
		},
		selected: {
			bg: 'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)',
			color: '#111',
			boxShadow: '2px 2px 4px 0 rgba(255,255,255,0.55) inset, -2px -2px 4px 0 #EC4A14 inset',
		},
		disabled: {
			bg: '#DFDEE7',
			color: { base: '#707070', lg: '#8F929F' },
			border: '1px solid #F0F0F0',
		},
	},
	betTypePick: {
		default: {
			bg: 'white',
			color: '#2D0707',
		},
		selected: {
			bg: 'radial-gradient(71.44% 43.55% at 11.35% 15%, rgba(107, 222, 235, 0.30) 0%, rgba(149, 207, 255, 0.00) 100%), linear-gradient(180deg, #A4C9EE 0%, #1143E6 100%)',
			color: 'white',
			boxShadow: '2px 2px 4px 0 rgba(255, 255, 255, 0.55) inset, -2px -2px 4px 0 #1426EC inset',
		},
		disabled: {
			bg: 'white',
			color: '#2D0707',
		},
	},
};

const SelectionButton = ({
	variant = 'numberPick',
	status = 'default',
	icon = null,
	children,
	onClick,
	borderRadius,
	isBetTypeEmpty,
	...props
}) => {
	const current = VARIANTS[variant][status] || VARIANTS[variant].default;

	const isDisabled = status === 'disabled' || status === 'soldOut';

	const isLg = useBreakpointValue({ base: false, lg: true });

	const showGradientBox = variant === 'quickPick' && status === 'selected' && !isDisabled && isLg;

	const button = (
		<Button
			gap={2}
			display='flex'
			alignItems='center'
			justifyContent='center'
			w={icon ? '40px' : 'full'}
			h='40px'
			p={icon ? 2 : 4}
			bg={current.bg}
			color={current.color}
			boxShadow={current.boxShadow}
			isDisabled={isDisabled}
			borderRadius={borderRadius}
			border={current.border}
			_hover={{ bg: current.bg }}
			_active={{ bg: current.bg }}
			_focus={{ boxShadow: current.boxShadow }}
			onClick={() => {
				onClick?.();
			}}
			{...props}
		>
			{children}
		</Button>
	);

	if (showGradientBox) {
		return (
			<GradientBox borderRadius={8} variant='goldYellow'>
				{button}
			</GradientBox>
		);
	}

	return button;
};

export default SelectionButton;
